import { render, staticRenderFns } from "./CancelBox.vue?vue&type=template&id=13b4b881&scoped=true"
import script from "./CancelBox.vue?vue&type=script&lang=js"
export * from "./CancelBox.vue?vue&type=script&lang=js"
import style0 from "./CancelBox.vue?vue&type=style&index=0&id=13b4b881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4b881",
  null
  
)

export default component.exports